import * as React from 'react'
import HomeIcon from '@mui/icons-material/Home'
import LogoutIcon from '@mui/icons-material/Logout'
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch'
import { Box, BottomNavigation, BottomNavigationAction, CssBaseline, Paper } from '@mui/material'

import { RequireAuth, useSignOut } from 'react-auth-kit'
import { useNavigate, useLocation } from 'react-router-dom'

import "../App.css"

const BottomNavBar = () => {

    const navigate = useNavigate()
    const location = useLocation()
    const signOut = useSignOut()

    
    const logOut = () => {
        signOut()
        navigate('/login')
    }

    const [value, setValue] = React.useState(0)
  
    return (
      <Box sx={{ pb: 7 }}>
        <CssBaseline />
      
        <Paper sx={{  position: 'fixed', bottom: 0, left: 0, right: 0 }} 
          elevation={3}
        >
          <BottomNavigation
            showLabels
            value={
                location.pathname == '/' ? 0 : 
                    (location.pathname == '/mpnlookup' ? 1 : 2)
            }
            // value={value}
            // onChange={(event, newValue) => {
            //   setValue(newValue)
            // }}
          >
            <BottomNavigationAction 
              label="Home" 
              onClick={() => navigate('/')}
              icon={<HomeIcon />}  
            />
            <BottomNavigationAction 
              label="Contract Lookup" 
              onClick={() => {
                navigate('/mpnlookup')
              }}
              icon={<ContentPasteSearchIcon />}
              />
    
            <BottomNavigationAction 
              label="Log Out" 
              onClick={logOut}
              icon={<LogoutIcon />} 

            />
          </BottomNavigation>
        </Paper>
      </Box>
    )
  }
  
  
  export default BottomNavBar